import { FC, useEffect, useRef } from 'react'

import SafetyCaseFormFields from './safety-case-form-fields'

import { ISafetyCaseFormProps } from './safety-case-form-types'

const SafetyCaseForm: FC<ISafetyCaseFormProps> = props => {
  const {
    handleSubmit,
    formName,
    submitting,
    baseStatus,
    additionalOptions,
    values,
    setForm,
    form,
    valid,
    onChange,
    disabled = false,
    isViewMode,
  } = props

  const prevValuesRef = useRef(values)
  useEffect(() => {
    if (typeof onChange === 'function') {
      if (values !== prevValuesRef.current) {
        onChange(values, valid)
        prevValuesRef.current = values
      }
    }
  }, [onChange, valid, values])

  useEffect(() => {
    setForm && setForm(form)
    // eslint-disable-next-line
  }, [setForm])

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <SafetyCaseFormFields
        disabled={submitting || disabled}
        baseStatus={baseStatus}
        additionalOptions={additionalOptions}
        isViewMode={isViewMode}
        addSelectedTagIds={form.mutators.addSelectedTagIds}
        values={values}
      />
    </form>
  )
}

export default SafetyCaseForm
